import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../config';

const Partner = ({ name, image = '', url = '' }) => {
  return (
    <div className="col-sm-2">
      <div className="partner">
        <a target="_blank" href={`${url}`}>
          <img src={`${IMAGES_REPO}${image}`} className="img-responsive img-centered" alt=""/>
        </a>
      </div>
    </div>
  );
};

class Partners extends PureComponent {

  render() {
    const { listOfPartners = [] } = this.props;

    if (listOfPartners.length === 0) {
      return <div/>;
    }

    return (
      <aside className="partners">
        <hr/>
        <div className="container">
          <h4>Partners</h4>
          <div className="row">
            {
              listOfPartners.map((partner, index) => {
                return (
                  <Partner key={index} {...partner}/>
                );
              })
            }
          </div>
        </div>
      </aside>
    );
  }
}

Partners.propTypes = {};
Partners.defaultProps = {};

export default Partners;



// WEBPACK FOOTER //
// ./src/components/partners/Partners.js